<template>
  <div :style="style" id="Login">
    <div class="login-warp">
      <div class="loginCon">
        <div class="left">
          <img :src="PCBanner?PCBanner:loginImg" alt="">
        </div>
        <div class="right">
          <div class="form">
            <h3 style="text-align:center">欢迎您登录展商服务平台</h3>
            <el-form :model="loginForm" ref="loginForm" :rules="rules">
              <p class="formItemT">用户名</p>
              <el-form-item prop="loginName">
                <el-input prefix-icon="el-icon-user" v-model="loginForm.loginName"></el-input>
              </el-form-item>
              <p class="formItemT">密码</p>
              <el-form-item prop="loginPwd">
                <el-input prefix-icon="el-icon-lock" show-password type="password" v-model="loginForm.loginPwd"></el-input>
              </el-form-item>
            </el-form>
            <div class="desc">
              <el-checkbox v-model="agreechecked"><span @click.stop="showagree = true">我已知晓并同意参展商政策全部内容</span></el-checkbox>
            </div>
            <div class="btnCollect">
              <el-button @click="login()" :style="buttonStyle" type="primary">登录</el-button>
              <el-button @click="navTo()" :style="buttonStyle" type="primary">注册</el-button>
            </div>
            <!-- <div class="flex space-between mt10">
              <el-link :underline="false" @click="$router.push('/regist')" type="info">注册</el-link>
              <el-link :underline="false" @click="$router.push('/regist')" type="info">忘记密码</el-link>
            </div>-->
          </div>
        </div>
      </div>
    </div>
    <div class="tipBtn" @click="dialogVisible=true">参展商承诺</div>
    <el-dialog
      title="“三个承诺”之参展商承诺"
      :visible.sync="dialogVisible"
      top='10vh'
      width="45%"
      center
    
      :close-on-click-modal='isClose'
      :close-on-press-escape='isClose'
      :modal-append-to-body='isClose'
      :append-to-body='isClose'
      :lock-scroll='isClose'>
      <div>
        <div class="tipContent">
          <div class="tipItem">本人承诺：主动上报本人与其他单位、个人等主体间发生的尚未处理完毕的各类矛盾纠纷，积极配合本人所在地司法调解部门做好矛盾纠纷化解工作，不得将矛盾纠纷带到展会现场，如因本人未如实上报相关情况，造成展会现场发生滋事扰序等情况的，本人愿意承担相关法律责任。</div>
          <div class="tipItem">本人承诺：切实提高安全防范意识，全民参与防范电信网络诈骗，不听、不信、不转账，不贪、不要、不上当，一旦难分真假，务必第一时间拨打国展派出所电话021-59720110咨询求助。</div>
          <div  class="tipItem">本人承诺：严格遵守国展中心禁限带物品进馆要求，不得将明文规定的禁限带物品和与此次展会活动无关的物品带入场馆，如有违反本人愿意承担相关法律责任。注：禁带物品是指违反中国法律法规的物品；限带物品是指虽然不违反中国法律法规，但可能影响国展中心安全和运营秩序，不得带入的物品。展品中如有刀具等涉及禁、限带物品的，要在展品进入国展中心前以书面形式（包括种类数量、入场时间、安全管理措施等）向安保部门备案。</div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false" >我已阅读</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="参展商政策相关条款"
      :visible.sync="showagree"
      top='10vh'
      width="45%"
      center
    
      :close-on-click-modal='isClose'
      :close-on-press-escape='isClose'
      :modal-append-to-body='isClose'
      :append-to-body='isClose'
      :lock-scroll='isClose'>
      <div>
        <div class="tipContent">
          <div class="tipItem">参展商应确保在本系统中所上传或填写的信息（包括但不限于公司或产品宣传的文字、logo、图片）真实有效；所提供的相关数据的来源合法，且其对该等数据的使用已取得相关数据主体的授权同意；相关宣传内容应符合相关法律法规（包括但不限于《广告法》、《反不正当竞争法》、《商标法》、《专利法》、《著作权法》等），均不侵犯任何第三方知识产权及其他合法权利，包括但不限于商标权、著作权、专利权及肖像权等。参展商如对上述要求有任何违反，主办方有权修改、删除相关内容或停止向展商提供服务，参展商应对前述违反情况承担全部责任，并赔偿因此对主办方造成的一切损失（包括但不限于对第三方的赔偿、罚款等）。</div>
          <div class="tipItem">参展商应按照展会主管部门要求，展前提交参展人员实名注册信息，并确保该信息真实有效，否则将无法进入展览场地。</div>
          <div class="tipItem">参展商知晓主办方可能会在展会现场拍摄宣传图片或视频等，并同意主办方将含有参展公司展位或名称、参展人员形象的照片或视频用于展会宣传之用途。</div>
          <div class="tipItem">主办方可以为了提供本系统服务内容而将该信息转交给第三方，也可以为实现其商业目的而处理和使用系统用户提供的数据；但前提是前述使用应遵守数据保护的相关法律。</div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="showagree = false" >我已阅读</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import { mapState } from 'vuex'
// import bgImg from '@/assets/login-bg.png'
import bgImg from '@/assets/loginBg.jpg'
import loginImg from '@/assets/login-img.png'
import sybg from '@/assets/sybg.png'
import api from '../api'
import tools from '../utils/tools.js'
export default {
  data() {
    return {
      loginForm: {},
      style: {
        background: `#fff url(${bgImg}) center/cover no-repeat`
      },
      formBg: {
        background: `url(${sybg}) repeat`
      },
      rules: {
        loginName: [
          {
            required: true,
            message: '用户名不能为空',
            trigger: 'change'
          }
        ],
        loginPwd: [
          {
            required: true,
            message: '密码不能为空',
            trigger: 'change'
          }
        ]
      },
      loginImg: loginImg,
      exhName: '',
      PCBanner: '',
      buttonStyle: null,
      isClose:false,
      dialogVisible:false,
      showagree: false,
      agreechecked: false
    }
  },
  computed: {
    ...mapState('status', {
      lg: (state) => {
        const lg = {
          right: {
            offset: 16,
            span: 6
          },
          center: {
            offset: 8,
            span: 8
          }
        }
        return lg[state.login.formPosition]
      },
      sm: (state) => {
        const sm = {
          right: {
            offset: 14,
            span: 8
          },
          center: {
            offset: 8,
            span: 8
          }
        }
        return sm[state.login.formPosition]
      },
      xl: (state) => {
        const xl = {
          right: {
            offset: 16,
            span: 4
          },
          center: {
            offset: 8,
            span: 8
          }
        }
        return xl[state.login.formPosition]
      }
    })
  },
  mounted() {
   localStorage.setItem('ExhID', this.$route.query.ExhID)
   this.getexhinfo()
   this.getselfbasicfield()
   this.navTo()
  },

  watch: {},
  methods: {
    getselfbasicfield () {
      api.getselfbasicfield({
        exhId: this.ExhID
      }).then(res => {
        if (res.data.code === 200) {
          var _data = res.data.data
          for (var i = 0; i < _data.length; i++) {
            sessionStorage.setItem(_data[i].scKey, _data[i].scValue)
          }
          this.PCBanner = sessionStorage.getItem('PCBanner')
          // this.bannerUrl = sessionStorage.getItem('banner') || ''
          this.buttonStyle = sessionStorage.getItem('buttonStyle') ? JSON.parse(sessionStorage.getItem('buttonStyle')) : {}
        } else {
          this.$toast.fail(res.data.msg)
        }
      })
    },
    getexhinfo() {
      api.getexhinfo().then(res => {
        if (res.data.code === 200) {
          sessionStorage.setItem('exhName', res.data.data.exhName)
          this.exhName = res.data.data.exhName
          // document.title = `${sessionStorage.getItem('exhName')}展商自助服务平台`;
          document.title = '展商报名';
        }
      })
    },
    navTo() {
      this.$router.push(`/SignUp`)
    },
    login() {
      this.$refs['loginForm'].validate((valid) => {
        if (valid) {
          if (this.agreechecked === false) {
            this.$notify({
              title: '请勾选并同意隐私协议！',
              type: 'error'
            })
            return false
          }
          api.login(this.loginForm).then((res) => {
            if (res.data.code === 200) {
              res.data.data.loginTime = new Date().getTime()

              localStorage.setItem('userInfo', JSON.stringify(res.data.data))
              localStorage.setItem('token', res.data.data.token)
              localStorage.setItem('loginName', this.loginForm.loginName)

              if(res.data.data.exhID){
                localStorage.setItem('ExhID', res.data.data.exhID)
              }
              
              // api.setHeader()
              this.$router.push('/landingPage')
              // this.$router.push('/boothBook')
            }
          })
        } else {
          this.$notify({
            title: '请检查表单填写项是否符合规范！',
            type: 'error'
          })
          return false
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.tipBtn{
  position: fixed;
  background:#409EFF;
  color:#fff;
  top:10%;
  right:0;
  font-size:16px;
  padding:16px 26px;
  cursor: pointer;
  z-index: 1111;
}
#Login {
  height: 100%;
  .login-warp {
    width: 980px;
    margin: 0 auto;
    padding: 60px 0 60px;
    position: relative;
    display: none;
    .loginCon{
      border-radius: 12px;
      overflow: hidden;
      position: relative;
      background: #fff;
      display: flex;
    }
    .left{
      // float: right;
      // width: 43%;
      // position: absolute;
      // left: 0;
      // top: 0;
      // height: 100%;
      background-repeat: no-repeat;
      background-position: 50%;
      background-size: cover;
      img{
        height: 650px;
        width: 100%;
      }
    }
    .right{
      // float: right;
      width: 480px;
      height: inherit;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      padding: 40px 0;
      position: relative;
      min-width: 460px;
    }
    .form {
      padding: 30px 60px 20px;
      border-radius: 4px;
      h3{
        text-align: left;
        padding-bottom: 50px;
        font-size: 20px;
        font-weight: 600;
      }
      .formItemT{
        font-weight: 400;
        font-size: 12px;
        padding: 0;
        line-height: 30px;
        width: 100%;
        display: inline-block;
      }
      .btnCollect{
        padding:45px 0 20px;
        .el-button{
          width: 100%;
          margin:16px 0;
        }
      }
    }
  }
  .tipContent{
    line-height: 30px;
    font-size:16px;
    .tipItem{
      padding-bottom: 10px;
      text-indent: 32px;
    }
  }
}
</style>
